import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { SmartInsightsResponse } from 'src/reactQuery/useGetSmartInsightsQuery'
import { analyticsApi } from 'src/services/analyticsApi'

interface UseGetProjectSmartInsightsQueryParams {
  fromDate?: string
  id?: string
  toDate?: string
}

export const useGetProjectSmartInsightsQuery = ({
  fromDate,
  id,
  toDate,
}: UseGetProjectSmartInsightsQueryParams) =>
  useQuery<SmartInsightsResponse>({
    enabled: !!id,
    queryFn: async () => {
      const response = await analyticsApi().get(
        `/v1_private/projects/${id}/smart-insights`,
        { params: { fromDate, toDate } }
      )
      return response.data
    },
    queryKey: [QueryKey.GET_PROJECT_SMART_INSIGHTS, id, fromDate, toDate],
  })
